import { RequestStatus } from 'clickNgo/configs/service/common'

import { IMasterDealerDataState } from './models'

export const INITIAL_STATE: IMasterDealerDataState = {
  base: {
    data: new Map([]),
    status: RequestStatus.NONE,
    message: '',
  },
  created: new Map([]),
  modified: new Map([]),
  deleted: new Map([]),
}

export const NAME = 'masterDealerData'

export const GET_MASTER_DEALER_DATA_BY_ID = `${NAME}/getMasterDealerDataById`

export const INIT_MASTER_DEALER_DATA_ACTION = `${NAME}/initMDDataAction`
